import { DishItem } from 'models/entities/dish-item';

type Data = {
  dishItems?: DishItem[];
};

class ExportDishItemsWithIngredientsTarget {

  readonly dishItems: DishItem[];

  constructor(data: Data = {}) {
    this.dishItems = data.dishItems ?? [];
  }

}

export { ExportDishItemsWithIngredientsTarget };
